import clsx from "clsx";
import AnimatedLink from "@/components/animated-link";
import Cta from "@/components/cta/cta";
import ArrowRight from "@/components/icon/arrow-right";


export default function TopicCard({ className = "", subtitleClassName = "", title, subtitle, children, href, label, ref }) {
  return (
    <AnimatedLink transitionName="overlay-in" href={href} label={label} className={clsx("flex flex-col py-(--space-7) xl:py-(--space-8) px-(--space-7) gap-(--space-3) lg:gap-(--space-5) w-full aspect-354/216 md:aspect-354/150 lg:w-76 lg:aspect-304/437 relative group overflow-hidden", className)} ref={ref}>
      <div className="absolute inset-0 bg-gradient-to-br from-black/0 to-black/25 opacity-0 group-hover:opacity-100 transition-opacity motion-safe:duration-300 pointer-events-none z-10" />
      {title && <h4 className="heading-4-small xl:heading-4 font-bold text-main-dark relative z-10">{title}</h4>}
      {subtitle && <p className={clsx("body-2-small xl:body-2 text-main-dark text-pretty relative z-10", subtitleClassName)}>{subtitle}</p>}
      <Cta className="cta-light cta-icon-stroke-theme cta-circle-small absolute max-lg:left-(--space-7) lg:right-(--space-7) bottom-(--space-7) z-10" aria-hidden="true"><ArrowRight className="!w-4" /></Cta>
      {children}
    </AnimatedLink>
  )
}